export type PermissionContext = 'Create' | 'Read' | 'Edit' | 'Delete'

export const checkCan = (
  authUser: any,
  screen: string,
  context: PermissionContext
): boolean => {
  if (authUser) {
    const permission = authUser.generalPermissions.find(
      (p: any) => p.screen === screen
    )
    if (!permission) {
      return false
    }
    if (context === 'Create' && permission.allowCreate) {
      return true
    }
    if (context === 'Delete' && permission.allowDelete) {
      return true
    }
    if (context === 'Edit' && permission.allowEdit) {
      return true
    }
    if (context === 'Read' && permission.allowRead) {
      return true
    }
  }
  return false
}
